import { formatMoney } from "@/glow";
import { qsa } from "@fluorescent/dom";

const {
  strings: { products: strings },
} = window.theme;

const selectors = {
  price: "[data-price]",
  comparePrice: "[data-compare-price]",
};

export default function (els, variant) {
  const prices = els.flatMap(el => qsa(selectors.price, el));
  const comparePrices = els.flatMap(el => qsa(selectors.comparePrice, el));
  const unavailableString = strings.product.unavailable;

  if (!variant) {
    prices.forEach(el => (el.innerHTML = unavailableString));
    comparePrices.forEach(el => (el.innerHTML = ""));
    return;
  }

  prices.forEach(el => (el.innerHTML = formatMoney(variant.price)));
  comparePrices.forEach(
    el =>
      (el.innerHTML =
        variant.compare_at_price > variant.price
          ? formatMoney(variant.compare_at_price)
          : "")
  );
}
